import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Heart } from 'lucide-react'
import { Button } from '@stvgroup/stv-ui-components'
import { API_IMAGE_OBJECT } from '../../utils/types'
import useProgrammeList from '../../customHooks/useProgrammeList'

const MyListButton = ({
  programme,
  sx,
}) => {
  const emitterRef = useRef(null)
  const { inStore, handleClick } = useProgrammeList({ ...programme, emitterRef })

  return (
    <Button
      aria-label={inStore()
        ? `remove ${programme.name} from my list`
        : `add ${programme.name} to my list`}
      startIcon={inStore()
        ? <Heart fill="#E83177" size={24} color="#E83177" />
        : <Heart fill="none" size={24} />}
      onClick={handleClick()}
      variant="text"
      disableRipple
      sx={{
        minWidth: 'auto',
        height: '42px',
        background: 'none',
        fontWeight: '400',
        fontSize: '18px',
        justifyContent: 'start',
        padding: '0px',
        alignItems: 'center',
        color: 'white',
        textTransform: 'capitalize',
        zIndex: 9,
        '&:hover': {
          color: 'white',
          '& .MuiButton-icon': {
            fill: '#E83177',
            color: '#E83177',
          },
        },
        '& .MuiButton-startIcon': {
          ml: 0,
        },
        ...sx,
      }}
      ref={emitterRef}
    >
      <span className="my-list-button-text">{(inStore() ? 'Remove' : 'My list')}</span>
    </Button>
  )
}

MyListButton.propTypes = {
  programme: PropTypes.shape({
    name: PropTypes.string,
    programmeGuid: PropTypes.string,
    image: API_IMAGE_OBJECT,
  }),
  sx: PropTypes.object,
}

MyListButton.defaultProps = {
  programme: {
    name: '',
    programmeGuid: '',
    image: {},
  },
  sx: {},
}

export default MyListButton
